module.exports = "agm-map {\r\n    height: 350px;\r\n  }"